import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
import BaseSettingHandler from './BaseSettingHandler';
import STORE from '@/app/store/store';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * Setting Pick Product
 */
export class ShProductPick extends BaseSettingHandler {
  /**
   * read setting
   * @param options options
   * @param options.$activePanel $activePanel
   */
  read(options: { $activePanel: JQuery; atomModel: AtomModel }) {
    const $atom = DataManager.getAtomDomById(options.atomModel.id);
    if ($atom) {
      const $target = $atom.find(this.setting.targetSelector as string);
      const value = $target.attr(this.setting.property) as string;
      options.$activePanel
        .find(`[name="${this.setting.name}"]`)
        .attr('value', value)
        .val(value)
        .trigger('value-change');
      return { value: value };
    }
  }

  /**
   * write setting
   * @param value value
   * @returns refreshType
   */
  write(
    value: string,
    options: {
      atomModel: AtomModel;
    },
  ) {
    const $atom = DataManager.getAtomDomById(options.atomModel.id);
    STORE.setValue(`product-${options.atomModel.id}-change-product`, true);
    const $target = $atom.find(this.setting.targetSelector as string);
    $target.attr(this.setting.property, value);
    return {
      refreshType: 'all',
    };
  }
}
